<template>
  <div id="topHeader">
    <a href="#">
      <img class="menu-logo" :src="themeData.lightLogoList" alt="sprout-pay">
    </a>
    <div class="right-align-area">
      <div class="user-info">
        <img class="user-avatar" src="@/assets/images/user-header.png" alt="user">
        <div>
          <a-dropdown>
            <a class="user-name" @click.prevent>
              {{ $store.getters.getUserInfo.merchantName }}
            </a>
            <template #overlay>
              <a-menu>
                <a-menu-item>
                  <a @click="$router.push('/user/account_materials')">{{ $t('pages_router_031') }}</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="$router.push('/user/user_manage')">{{ $t('pages_router_032') }}</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="$router.push('/user/account_security')">{{ $t('pages_router_033') }}</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="signOut">{{ $t('pages_main_028') }}</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </div>
      <div class="lang-select">
        <global-outlined class="ic-global" />
        <lang-selector />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, inject, reactive, toRefs, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
// import { useStore } from 'vuex'
import { localStorageClear } from '@/util'
import { _login } from '@/api/index'
import Cookies from 'js-cookie'
import LangSelector from '@/components/lang-sel'

export default defineComponent({
  name: 'TopHeader',
  components: {
    'lang-selector': LangSelector
  },
  setup() {
    let timer = null
    const router = useRouter()
    // const store = useStore()
    const state = reactive({
      themeData: inject('$themeData'),
      currentTime: new Date().getTime(),
      baseUrl: window.location.protocol + '//' + window.location.host
    })
    onUnmounted(() => {
      window.onmousemove = null
      clearInterval(timer)
    })
    const init = async () => {
      loadMouseWatch()
      loadTimer()
    }
    const signOut = async () => {
      await _login.loginOut()
      Cookies.remove('last_page_name')
      Cookies.remove('SESSION_ID')
      localStorageClear()
      router.replace('/login')
    }
    const loadIsExpired = () => {
      if (new Date().getTime() - state.currentTime > 5 * 1000 * 60) {
        clearInterval(timer)
        router.push('/user_leave')
      }
    }
    const loadTimer = () => {
      timer = setInterval(() => {
        loadIsExpired()
      }, 5000)
    }
    const loadMouseWatch = () => {
      window.onmousemove = () => {
        state.currentTime = new Date().getTime()
      }
    }

    init()

    return {
      signOut,
      init,
      ...toRefs(state)
    }
  }
})
</script>

<style lang="less">
#topHeader {
  background: #fff;
  height: 60px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  .menu-logo {
    width: 120px;
    margin: 15% 11% 12% 11%;
  }
  .right-align-area {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-right: 20px;
    .user-info {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-right: 20px;
      // mouse move to highlight
      .user-name:hover {
        color: #5e6bf7;
      }
      .user-name {
        font-size: 16px;
        font-weight: 600;
        color: #000;
        margin-right: 10px;
        width: 120px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #f0f0f0;
        margin-right: 10px;
      }
    }
    .lang-select {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .lang-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .lang-name {
        font-size: 16px;
        font-weight: 600;
        color: #5e6bf7;
        margin-right: 10px;
      }
    }
  }
}
</style>
